import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-banner-cta',
    templateUrl: './banner-cta.component.html',
    styleUrls: ['./banner-cta.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BannerCtaComponent {}
